import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  MultiAutocomplete,
  RadioGroup,
  Select,
} from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function Relabastecimentocontingencia() {
  const [open, setOpen] = useState(true);
  const [posto, setPosto] = useState(0);
  const [bico, setBico] = useState(0);

  const [valuePosto, setValuePosto] = React.useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');
  const [valueBico, setValueBico] = React.useState(0);
  const [inputValueBico, setInputValueBico] = React.useState('');

  const tipoabastecimento = [
    { label: t('s.relatorio.geral.todos'), value: 'null' },
    { label: t('s.relatorio.abastecimentocontingencia.abas'), value: '1' },
    { label: t('s.relatorio.abastecimentocontingencia.vtab'), value: '2' },
    { label: t('s.relatorio.abastecimentocontingencia.dppt'), value: '3' },
    { label: t('s.relatorio.abastecimentocontingencia.dkpd'), value: '4' },
    { label: t('s.relatorio.abastecimentocontingencia.dped'), value: '5' },
  ];

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });

  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsCompany = useMemo(
    () => [
      {
        id: 'idempresaveiculo',
        label: t('s.cadastro.empresaveiculo.idempresaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeempresaveiculo',
        label: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsVehicle = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('s.configuracao.comboio.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'placaveiculo',
        label: t('s.cadastro.veiculo.placaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodeloveiculo',
        label: t('s.menu.cadastro.veiculo.modelo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const orderoptions = [
    { value: 'LI', label: t('s.relatorio.abastecimento.opcaolistagem') },
    { value: 'BI', label: t('s.relatorio.abastecimento.opcaobico') },
    { value: 'DT', label: t('s.relatorio.abastecimento.opcaodata') },
    { value: 'FT', label: t('s.relatorio.abastecimentolistagem.frentista') },
    { value: 'FR', label: t('s.relatorio.abastecimento.opcaofrota') },
    { value: 'PC', label: t('s.relatorio.abastecimento.opcaopostocomboio') },
    { value: 'EM', label: t('s.cadastro.veiculo.nomeempresaveiculo') },
    {
      value: 'CT',
      label: t('s.geral.camposistema.contingenciamovimentacaoabastecimento'),
    },
  ];

  function handleSerializeForm(params) {
    const idPosto =
      valuePosto === 0 ? '' : valuePosto?.map((posto) => posto.idposto);
    const idBico = valueBico === 0 ? '' : valueBico;

    return {
      ...params,
      idposto: idPosto,
      idbico: idBico,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.abastecimentocontingencia')}
      relatorio="abastecimentocontingencia"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        contingenciamovimentacaoabastecimento: 'null',
        tipoordenacaoreport: 'LI',
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          if (value[0]?.idposto === null) {
            setValuePosto(0);
            setInputValuePosto('');
            setValueBico(0);
            setInputValueBico('');
            setPosto(0);
            setBico(0);
          } else {
            setValuePosto(value);
            setPosto(value);
            setValueBico(0);
            setInputValueBico('');
          }
        }}
      />

      <Autocomplete
        name="idbico"
        label="bicoprodutobico"
        url="bicos"
        unique="idbico"
        title={t('s.menu.configuracao.bico')}
        value={valueBico}
        inputValue={inputValueBico}
        onChange={(event, newValue) => {
          setValueBico(newValue);
        }}
        onInputChange={(event, newInputValueBico) => {
          setInputValueBico(newInputValueBico);
        }}
        disabled={valuePosto.length === 0 || valuePosto.length > 1}
        getValue={(value) => {
          setValueBico(value.idbico);
          if (value.idbico === null) {
            setBico(0);
          } else {
            setBico(value.idbico);
          }
        }}
        params={{
          wherefield: 'idposto',
          valuewherefield: valuePosto[0]?.idposto,
          typewherefield: 'EQUALS',
        }}
      />

      <Select
        name="contingenciamovimentacaoabastecimento"
        label={t(
          's.operacao.abastecimento.contingenciamovimentacaoabastecimento'
        )}
        options={tipoabastecimento}
      />

      <PesquisaTabela
        name="idempresaveiculo"
        label={t('s.menu.cadastro.veiculo.empresa')}
        primary="idempresaveiculo"
        secondary="nomeempresaveiculo"
        url="empresasveiculos"
        header={cellsCompany}
      />

      <PesquisaTabela
        name="idveiculo"
        label={t('s.menu.cadastro.veiculo')}
        primary="idveiculo"
        secondary="nomemodeloveiculo"
        url="veiculos"
        header={cellsVehicle}
      />

      <PesquisaTabela
        name="frentista"
        label={t('s.relatorio.abastecimentocontingencia.frentista')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={cellsUser}
      />

      <Select
        name="tipoordenacaoreport"
        variant="outlined"
        size="small"
        label={t('s.relatorio.abastecimento.tipoordenacao')}
        options={orderoptions}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relabastecimentocontingencia;
